const progressions = [
  [
    // scaleDegree, octaveDisplacement, startBeat, stopBeat, velocity
    [1, 1, 0, 1.1, 0.7],
    [5, 0, 0, 1.1, 0.5],
    [3, 0, 0, 1.1, 0.5],
    [1, 0, 0, 1.1, 0.6],

    [1, 1, 1, 2.1, 0.75],
    [6, 0, 1, 2.1, 0.55],
    [3, 0, 1, 2.1, 0.55],
    [6, -1, 1, 2.1, 0.65],

    [2, 1, 2, 3.15, 0.8],
    [6, 0, 2, 3.15, 0.6],
    [4, 0, 2, 3.15, 0.6],
    [4, -1, 2, 3.15, 0.7],

    [7, 0, 3.05, 4.25, 0.7],
    [5, 0, 3.05, 4.25, 0.5],
    [4, 0, 3.05, 4.25, 0.5],
    [5, -1, 3.05, 4.25, 0.6],

    [1, 1, 4.125, 7, 0.5],
    [5, 0, 4.125, 7, 0.4],
    [3, 0, 4.125, 7, 0.3],
    [1, 0, 4.125, 7, 0.4],
  ],
  [
    [3, 1, 0, 0.9, 0.7],
    [1, 1, 0, 0.9, 0.5],
    [5, 0, 0, 0.9, 0.5],
    [1, 0, 0, 0.9, 0.6],

    [2, 1, 1, 3.1, 0.75],
    [1, 1, 1, 3.1, 0.55],
    [6, 0, 1, 3.1, 0.55],
    [4, -1, 1, 3.1, 0.65],

    [2, 1, 3, 4.15, 0.8],
    [7, 0, 3, 4.15, 0.6],
    [5, 0, 3, 3.7, 0.6],
    [5, -1, 3, 4.15, 0.7],

    [4, 0, 3.54, 4.15, 0.6],

    [1, 1, 4.125, 7, 0.5],
    [5, 0, 4.125, 7, 0.4],
    [3, 0, 4.125, 7, 0.3],
    [1, 0, 4.125, 7, 0.4],
  ],
  [
    [3, 1, 0, 1.1, 0.7],
    [1, 1, 0, 1.1, 0.5],
    [5, 0, 0, 1.1, 0.5],
    [1, 0, 0, 1.1, 0.6],

    [4, 1, 1, 2.1, 0.75],
    [1, 1, 1, 2.1, 0.55],
    [6, 0, 1, 2.1, 0.55],
    [6, -1, 1, 2.1, 0.65],

    [5, 1, 2, 3.15, 0.8],
    [1, 0, 2, 3.15, 0.6],
    [5, 0, 2, 3.15, 0.6],
    [3, -1, 2, 3.15, 0.7],

    [7, 0, 3.05, 4.25, 0.7],
    [5, 0, 3.05, 4.25, 0.5],
    [4, 0, 3.05, 4.25, 0.5],
    [5, -1, 3.05, 4.25, 0.6],

    [1, 1, 4.125, 7, 0.5],
    [5, 0, 4.125, 7, 0.4],
    [3, 0, 4.125, 7, 0.3],
    [1, 0, 4.125, 7, 0.4],
  ],
  [
    [5, 1, 0, 1.1, 0.7],
    [3, 1, 0, 1.1, 0.5],
    [5, 0, 0, 1.1, 0.5],
    [1, 0, 0, 1.1, 0.6],

    [4, 1, 1, 2.1, 0.75],
    [2, 1, 1, 2.1, 0.55],
    [6, 0, 1, 2.1, 0.55],
    [4, -1, 1, 2.1, 0.65],

    [3, 1, 2, 3.15, 0.8],
    [1, 1, 2, 3.15, 0.6],
    [5, 0, 2, 3.55, 0.6],
    [5, -1, 2, 4.25, 0.7],

    [2, 1, 3.05, 4.25, 0.7],
    [7, 0, 3.05, 4.25, 0.5],
    [4, 0, 3.59, 4.25, 0.5],

    [1, 1, 4.125, 7, 0.5],
    [5, 0, 4.125, 7, 0.4],
    [3, 0, 4.125, 7, 0.3],
    [1, 0, 4.125, 7, 0.4],
  ],
  [
    [3, 1, 0, 1.1, 0.7],
    [1, 0, 0, 1.1, 0.5],
    [5, 0, 0, 1.1, 0.5],
    [1, 0, 0, 1.1, 0.6],

    [5, 1, 1, 2.1, 0.75],
    [1, 0, 1, 2.1, 0.55],
    [5, 0, 1, 2.1, 0.55],
    [3, -1, 1, 2.1, 0.65],

    [4, 1, 2, 3.15, 0.8],
    [1, 0, 2, 3.15, 0.6],
    [6, 0, 2, 3.15, 0.6],
    [4, -1, 2, 3.15, 0.7],

    [2, 1, 3.05, 4.25, 0.7],
    [7, 0, 3.05, 4.25, 0.5],
    [4, 0, 3.05, 4.25, 0.5],
    [5, -1, 3.05, 4.25, 0.6],

    [1, 1, 4.125, 7, 0.5],
    [5, 0, 4.125, 7, 0.4],
    [3, 0, 4.125, 7, 0.3],
    [1, 0, 4.125, 7, 0.4],
  ],
  [
    [3, 1, 0, 2.1, 0.7],
    [1, 1, 0, 2.1, 0.4],
    [5, 0, 0, 2.1, 0.4],
    [1, 0, 0, 2.1, 0.5],

    [2, 1, 2, 3.1, 0.8],
    [1, 1, 2, 3.1, 0.65],
    [6, 0, 2, 3.1, 0.6],
    [4, -1, 2, 3.1, 0.7],

    [2, 1, 3, 4.4, 0.7],
    [7, 0, 3, 4.4, 0.5],
    [5, 0, 3, 3.7, 0.5],
    [5, -1, 3, 4.4, 0.6],

    [4, 0, 3.55, 4.4, 0.35],

    [1, 1, 4.25, 8, 0.6],
    [5, 0, 4.25, 8, 0.2],
    [3, 0, 4.25, 8, 0.2],
    [1, 0, 4.25, 8, 0.4],
  ],
];

export default progressions;
